<template>
	<mobile v-if="$res.xsmall()" v-bind="props"/>
	<desktop v-else v-bind="props"/>
</template>

<script>
import {pick} from "lodash";
import desktop from "./desktop/index.vue";
import mobile from "./mobile/index.vue";

export default {
	components: {desktop, mobile},
	computed: {
		routerLoaded: (t) => t.$route.name,
		categories: (t) => t.$store.getters["categories/data"],
		itemsCount: (t) => t.$store.getters["cart/itemsCount"],

		props: (t) => pick(t, [
			"routerLoaded",
			"categories",
			"itemsCount",
			"minicart",
			"update",
			"logout"
		])
	},
	methods: {
		async update({query, route} = {}) {
			await this.$store.dispatch("products/data", {query, route});
		},
		logout() {
			this.$store.dispatch("user/logout");
		},
		minicart() {
			this.$store.commit("cart/minicart", !this.$store.getters["cart/minicart"]);
		}
	},
	created() {
		this.$store.dispatch("categories/data");

		this.$router.onReady(() => {
			this.update({route: false})
		});
	}
};
</script>
